import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.addEventListener('turbo:load', this.onTurboLoad)
    document.addEventListener('turbo:frame-load', this.onTurboFrameLoad)
    this.onTurboLoad()
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.onTurboLoad)
    document.removeEventListener('turbo:frame-load', this.onTurboFrameLoad)
  }

  onTurboLoad = () => {
    this.initializeSurveyForm()
    this.handleSurveyDisplay()
  }

  onTurboFrameLoad = (event) => {
    if (event.target.id === 'student_results') {
      this.initializeSurveyForm()
    }
  }

  closeForm() {
    localStorage.setItem('survey_last_shown', new Date().toISOString())
    document.querySelector('.feedback-form')?.style.setProperty('display', 'none')
  }

  setSmileRating(event) {
    const value = parseInt(event.params.setSmileRating, 10);
    document.getElementById('smile-rating-value').value = value;

    document.querySelectorAll('.aq-smile-rating-button').forEach((button) => {
      const buttonValue = parseInt(button.dataset.surveyFormSetSmileRatingParam, 10);
      button.classList.toggle('active', buttonValue === value);
    });

    document.getElementById('success-message').style.display = 'none';
    const submitButton = document.querySelector('.submit-button');
    if (submitButton) submitButton.disabled = false;
  }

  initializeSurveyForm() {
    const form = document.querySelector('.feedback-form form')
    if (form) {
      form.addEventListener('submit', (event) => {
        const ratingValue = document.getElementById('smile-rating-value').value

        if (!ratingValue) {
          event.preventDefault()
          const submitButton = document.querySelector('.submit-button')
          if (submitButton) submitButton.disabled = true
        } else {
          document.getElementById('survey-dialog').style.display = 'none'
          document.querySelector('.submit-button')?.style.setProperty('display', 'none')
          document.getElementById('success-message').style.display = 'block'

          document.querySelectorAll('.submit-button').forEach(element => {
            element.disabled = true
          })

          this.closeForm();
        }
      }, { once: true })
    }
  }

  handleSurveyDisplay() {
    const now = new Date()
    const isSurveyActive = document.getElementById('delivery-survey-flag')?.value === 'true' || document.getElementById('report-survey-flag')?.value === 'true'
    const lastShown = localStorage.getItem('survey_last_shown')
    const feedbackForm = document.querySelector('.feedback-form')

    // Always show if survey is not active
    if (!isSurveyActive) {
      feedbackForm?.style.removeProperty('display')
      return
    }

    // Show if lastShown is null or more than 24 hours ago
    if (!lastShown || ((now - new Date(lastShown)) / (1000 * 60 * 60)) >= 24) {
      feedbackForm?.style.removeProperty('display')
    }
  }
}
